import styled from 'styled-components';

export const StyleInput = styled.input`
  background: #FFFFFF;
  border: 1px solid #CCCCCC;
  box-sizing: border-box;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  height: 50px;
  outline: none;
  padding: 10px;
  width: 100%;

  &:focus {
    box-shadow: -2px 9px 6px -5px rgba(0,0,0,0.27);
    transition: box-shadow 0.3s ease-in-out;
  }
`;